import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as ArrowDownIcon } from '@elementary/common-ui/assets/arrow-down-expand.svg';
import { Flex, IconButton } from '@elementary/common-ui/components';
import useIsOverflow from '@elementary/common-ui/hooks/useIsOverflow';
import { Typography } from '@mui/material';

const ArrowDownIconStyled = styled(ArrowDownIcon)<{ $flip: boolean }>`
  transform: ${({ $flip }) => ($flip ? 'rotate(-180deg)' : undefined)};
  transition: transform 0.1s;
  min-width: 10px;
`;

const DescriptionColumnRenderer = ({ text }: { text: string }) => {
  const [expanded, setExpanded] = useState(false);
  const descRef = useRef<any>();
  const isOverflow = useIsOverflow(descRef, true, [text, expanded]);

  useEffect(() => {
    setExpanded(false);
  }, [text]);

  return (
    <Flex
      sx={{
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        height: expanded ? 'auto' : '20px',
        gap: 1,
      }}
    >
      <Typography
        ref={descRef}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: expanded ? 'pre-wrap' : 'auto',
        }}
      >
        {text}
      </Typography>
      {(isOverflow || expanded) && (
        <IconButton
          sx={{ mt: 0.5 }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          <ArrowDownIconStyled $flip={expanded} />
        </IconButton>
      )}
    </Flex>
  );
};

export default DescriptionColumnRenderer;
